@use 'themes/westfield' as *;
@use 'tools/dirg' as *;
@use 'tools/dirg-breakpoint' as *;

.onboardingPage {
  margin: 0 auto;

  @include fromBreakpoint(tablet) {
    max-width: columns(7.5);
  }
}
